export const layoutLeftSide = {
  menu: {
    goTo: 'Aller vers: ',
    activeLink: 'lien actif',
    home: 'Accueil',
    programs: 'Programmes',
    specialWeapons: 'Armes supérieures',
    storage: 'Mémoire cache',
    users: 'Utilisateurs',
    videos: 'Vidéos',
    contact: 'Contact',
    cgu: 'CGU',
    conditionsUtilisation: "Conditions d'utilisation",
    mentionsLegales: 'Mentions légales',
    a11y: 'Accessibilité',
    a11yConformity: 'Partiellement conforme',
    changelog: 'Notes de version',
    session: 'Session',
    console: 'Console',
  },
};
